/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiPermission,
    ApiPermissionFromJSON,
    ApiPermissionToJSON,
} from '../models';

/**
 * 
 */
export class PermissionApi extends runtime.BaseAPI {

    /**
     * Fetches all user permissions
     */
    async findAllPermissionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiPermission>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiPermissionFromJSON));
    }

    /**
     * Fetches all user permissions
     */
    async findAllPermissions(initOverrides?: RequestInit): Promise<Array<ApiPermission>> {
        const response = await this.findAllPermissionsRaw(initOverrides);
        return await response.value();
    }

}
